import {
  isTerminalOperationState,
  normalizePreparedOperationReference,
  normalizePreparedOperationResponse,
} from "../api/schemas";
import { runDirectWalletOperation } from "./directWalletOrchestrator";
import { runMetaKeepOperation } from "./metaKeepOrchestrator";
import {
  isReconcileOnlyOperationState,
  reconcileOperationUntilTerminal,
} from "./operationReconciliation";

export const runPreparedCarbonOperation = async ({
  prepareResponse,
  sdk,
  operationClient,
  resolveDirectWalletContext,
  store = null,
  poll = true,
  maxPolls = 5,
  pollIntervalMs = 1000,
  executeMetaKeep = runMetaKeepOperation,
  executeDirect = runDirectWalletOperation,
  beforeSubmit,
  onSubmittedTransaction,
} = {}) => {
  const reference = normalizePreparedOperationReference(prepareResponse);
  if (isTerminalOperationState(reference.state)) {
    return reference;
  }
  if (isReconcileOnlyOperationState(reference.state)) {
    return reconcileOperationUntilTerminal({
      operationClient,
      operationId: reference.operationId,
      store,
      poll,
      maxPolls,
      pollIntervalMs,
    });
  }

  const operation = normalizePreparedOperationResponse(prepareResponse);

  if (operation.executionMode === "METAKEEP_BUSINESS_WALLET") {
    return executeMetaKeep({
      prepareResponse: operation,
      sdk,
      operationClient,
      store,
      poll,
      maxPolls,
      pollIntervalMs,
    });
  }

  if (operation.executionMode === "DIRECT_WALLET") {
    if (!resolveDirectWalletContext?.call) {
      throw new Error("direct-wallet execution context is required");
    }
    const context = await resolveDirectWalletContext();
    return executeDirect({
      prepareResponse: operation,
      signer: context?.signer,
      connectedChainId: context?.connectedChainId,
      operatorWalletAddress: context?.operatorWalletAddress,
      operationClient,
      store,
      poll,
      maxPolls,
      pollIntervalMs,
      ...(beforeSubmit === undefined ? {} : { beforeSubmit }),
      ...(onSubmittedTransaction === undefined
        ? {}
        : { onSubmittedTransaction }),
    });
  }

  throw new Error(`unsupported prepared operation mode: ${operation.executionMode}`);
};
